import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { FilesModule } from '@core/components/files/files.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillMultipleChoiceV1FieldComponent } from './fill-multiple-choice-v1/fill-multiple-choice-v1.component';
import { ViewMultipleChoiceV1FieldComponent } from './view-multiple-choice-v1/view-multiple-choice-v1.component';
import { SettingsMultipleChoiceV1FieldComponent } from './settings-multiple-choice-v1/settings-multiple-choice-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        FilesModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillMultipleChoiceV1FieldComponent,
        ViewMultipleChoiceV1FieldComponent,
        SettingsMultipleChoiceV1FieldComponent
    ],
    exports: [
        FillMultipleChoiceV1FieldComponent,
        ViewMultipleChoiceV1FieldComponent,
        SettingsMultipleChoiceV1FieldComponent
    ],

})
export class CoreCustomFormsFieldMultipleChoiceV1FieldsModule { }
